import React from 'react';
import {Card, CardBody, CardHeader} from "reactstrap";
import {getByModuleId, MODULE_BODY_GRAPHICS} from "../Modules";
import BodyGraphicsSelect from "./BodyGraphicsSelect";
import appUserRoutes from "../../../appUserRoutes";
import {Link} from "react-router-dom";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const BodyGraphicsCard = () => {
  const { ident, showType } = useTecRmi()

  return <Card className="h-100">
    <CardHeader className="p-1">
      <Link className="d-flex flex-row flex-nowrap align-items-center py-1" to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'))}>
        <img src={getByModuleId(MODULE_BODY_GRAPHICS, 'icon')} style={{ height: 24 }} />
        <span className="ml-1">{getByModuleId(MODULE_BODY_GRAPHICS, 'name')}</span>
      </Link>
    </CardHeader>
    <CardBody className="p-0">
      <BodyGraphicsSelect svgStyled={false} />
    </CardBody>
  </Card>;
};

BodyGraphicsCard.propTypes = {

};

export default BodyGraphicsCard;